const mapConstants = {
  MAP: 'USER_MAP_LOCATION',
  CLEAR: 'CLEAR',
}
export default mapConstants
